<template>
  <div>
    <label v-if="label" :for="selectId" class="label">
      {{ label }}
    </label>
    <multiselect
      :track-by="trackBy"
      :label="optionLabel"
      :id="selectId"
      :value="value" 
      @input="onChange" 
      :options="options"
      :allow-empty="false" 
      :preselect-first="selectFirstByDefault"
      class="multiselect"
    >
    <span slot="noResult" class="multiselect__noResult">
      <div class="multiselect__noResult-text"> There are no entries yet...</div>
    </span>
    </multiselect>
  </div>
</template>


<script>
import Multiselect from 'vue-multiselect';

export default {
  components: {
    Multiselect,
  },
  props: {
    trackBy: {
      type: String,
      default: 'value',
    },
    optionLabel: {
      type: String,
      default: 'value',
    },
    value: Object,
    options: Array,
    selectId: String,
    label: String,
    selectFirstByDefault: Boolean,
  },
  methods: {
    onChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style lang="scss">
.label {
  @include label;
}
$font-size: 14px;
.multiselect {
  background: $white-color2;
  appearance: none;
  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.09);
  border-radius: 5px;
  @include font($font-size);
  outline: none;
  padding: 22px 20px;
  min-width: 180px;
  width: 100%;
  max-width: 420px;
  position: relative;
  display: flex;
  &__single {
    font-weight: 500;
  }
}
.multiselect__tags {
  cursor: text;
  @include trimOverflowText(calc(100% - 30px));
  input {
    outline: none;
    width: 100%;
    border: none;
    @include font($font-size, $black-color1, 500);
    &::placeholder {
      font-weight: 500;
    }
  }
}
.multiselect__input {
  padding: 0;
  caret-color: $red-color3;
}
.multiselect__content-wrapper {
  min-height: 50px;
  overflow-y: auto;
  position: absolute;
  top: 55px;
  left: 0;
  background: $white-color2;
  width: 100%;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.09);
  border-radius: 0 0 5px 5px;
  z-index: 1;
}
.multiselect {
  cursor: pointer;
  li:not(#{&}__element) {
    padding: 0;
    &:hover {
      background: none;
    }
  }
  &__content {
    padding: 0;
    margin: 0;
    list-style: none;
    width: 100%;
    position: relative;
    top: 5px;
  }
  &__element {
    cursor: pointer;
    user-select: none;
    padding: 0 20px;
    &:last-child:hover {
      border-radius: 0 0 5px 5px;
    }
    &:hover {
      background: $red-color3;
      color: $white-color2;
    }
  }
  &__option {
    & > span {
      height: 60px;
      align-items: center;
      display: flex;
      @include trimOverflowText(100%);
      font-weight: 500;
    }
  }
  &__noResult {
    height: 45px;
    border-top: 1px solid $grey-color3;
    display: flex;
    align-items: center;
    padding: 0 21px;
    cursor: auto;
    @include font(13px, $grey-color9, 500);
  }
  &__noResult-text {
    margin-top: -6px;
  }
}

.multiselect__select {
  background: url("~src/assets/svg/arrow.svg") no-repeat;
  background-size: contain;
  width: 12px;
  height: 8px;
  display: block;
  right: 24px;
  align-self: center;
  position: absolute;
  cursor: pointer;
  transform: rotate(180deg);
  transition: $transition transform;
}

.multiselect--active {
  border-radius: 5px 5px 0 0;
  .multiselect__select {
    transform: rotate(0deg);
  }
}
.chart-selectbox .multiselect {
  padding: 12px 20px;
  min-width: 163px;
  $height: 40px;
  &__content-wrapper {
    top: $height;
  }
  &__noResult {
    justify-content: center;
  }
  &__noResult-text {
    margin-top: 0;
  }
  &__option > span {
    height: $height;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/uikit/SelectBox.vue